import {MessagesWithIndexSignature} from '@/types/generic.types';
import {isDefined} from '@/utils/typeGuards/isDefined';
import {useIntl} from 'react-intl';
import {UserExperience} from '../../../../utils';
import messages, {monthMessages} from './messages';

const typedMonthMessages = monthMessages as MessagesWithIndexSignature;

export const isEmpty = (userExperience: UserExperience) => {
    return (
        !userExperience.jobTitle &&
        !userExperience.companyName &&
        !userExperience.description &&
        !userExperience.startDate &&
        !userExperience.endDate
    );
};

export const useFormatTitle = (userExperience: UserExperience) => {
    const {jobTitle, companyName} = userExperience;

    if (!jobTitle && !companyName) {
        return '?';
    }

    if (!jobTitle) {
        return `? - ${companyName}`;
    }

    if (!companyName) {
        return `${jobTitle} - ?`;
    }

    return `${jobTitle} - ${companyName}`;
};

export const useFormatPeriod = (userExperience: UserExperience) => {
    const {startDate, endDate} = userExperience;
    const formattedStartDate = useFormatDate(startDate, true);
    const formattedEndDate = useFormatDate(endDate);

    if (formattedStartDate === '?' && formattedEndDate === '?') {
        return '?';
    }

    return `${formattedStartDate} - ${formattedEndDate}`;
};

const useFormatDate = (date?: Date | null, displayNullWithQuestionMark: boolean = false) => {
    const {year, month} = useDateParts(date);
    const monthText = useMonthToText(month);
    const intl = useIntl();

    if (date === null && !displayNullWithQuestionMark) {
        return intl.formatMessage(messages.present);
    }

    if (!isDefined(date)) {
        return '?';
    }

    return `${monthText} ${year}`;
};

const useDateParts = (date?: Date | null) => {
    if (!date) {
        return {year: null, month: null};
    }

    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    return {year, month};
};

const useMonthToText = (month: number | null) => {
    const intl = useIntl();
    if (!isDefined(month)) {
        return null;
    }

    return intl.formatMessage(typedMonthMessages[month]);
};
